import { css } from '@emotion/react'
import { mTheme } from '../../style/themes'

let { size, pageWidth, fontColor, fontSize, breakpoint } = mTheme

export const form: Style = css({
  display: 'flex',
  flexDirection: 'column',
  gap: size.S,
  width: '100%',
  alignItems: 'center',
  maxWidth: pageWidth.L,
})

export const formInner: Style = css({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  justifyContent: 'center',
  gap: size.M,
  [breakpoint.medium]: {
    flexDirection: 'row',
  },
})

export const secondary = css({
  color: fontColor.plain.secondary,
})

export const formSection: Style = () => ({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  gap: size.S,
})

export const textField: Style = css({
  width: '100%',
})

export const label: Style = css({
  color: fontColor.plain.primary,
  fontSize: fontSize.S,
  paddingBottom: '2px',
  marginLeft: size.XS,
})

export const margin: Style = css({
  width: '100%',
  margin: `${size.XS} 0`,
})

export const dateDropdownsContainer: Style = css({
  display: 'flex',
  flex: 1,
  alignItems: 'stretch',
})

export const middleDropdown: Style = css({
  margin: `0 ${size.XS}`,
})

export const signupButton: Style = css({})

export const smallText: Style = css({
  fontSize: fontSize.XS,
})
